import React, { useState, useEffect } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import { Link, useHistory } from "react-router-dom";
import {Row, Col, Form, Button, Image, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useSignIn, useIsAuthenticated, useAuthUser } from 'react-auth-kit';
import * as Icon from 'react-feather';


function Login(props)  {
    const authHeader = useAuthHeader();

    const signIn = useSignIn();
    const isAuthenticated = useIsAuthenticated();
    const authUser = useAuthUser();
    const history = useHistory();
    const apiUrl = process.env.REACT_APP_URL;
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Debug effect to check authentication status
    useEffect(() => {
        const authenticated = isAuthenticated();
        const user = authUser();

        // If already authenticated, redirect to dashboard
        if (authenticated) {
            history.push('/flotilla');
        }
    }, [isAuthenticated, authUser, history]);

    const onLoginHandler = (event) => {
        event.preventDefault();
        setError('');
        setLoading(true);

        const form = event.currentTarget;
        const email = form.elements.email?.value || '';
        const password = form.elements.password?.value || '';
        const data = { email, password };

        axios({
            method:'POST',
            url:apiUrl+'/users/login',
            headers: {
                Authorization: authHeader()
            },
            data: data
        }).then(response => {
            // Axios automatically parses JSON, so response.data is already an object
            const responseData = response.data;

            if (responseData.access_token) {
                // Get user data from response (includes roles)
                const userData = responseData.user || {};

                signIn({
                    token: responseData.access_token,
                    expiresIn: 604800, // 7 days in seconds (matches backend)
                    tokenType: "Bearer",
                    authState: {
                        id: userData.id,
                        email: userData.email || data.email,
                        first_name: userData.first_name,
                        last_name: userData.last_name,
                        roles: userData.roles || [],
                        permissions: userData.permissions || [],
                        is_company_admin: userData.is_company_admin || false,
                        client_id: userData.client_id || null,
                        client: userData.client || null,
                        msg: responseData.msg
                    },
                    refreshToken: responseData.refresh_token
                });

                setLoading(false);

                // Add a small delay to ensure state is updated
                setTimeout(() => {
                    history.push('/flotilla');
                }, 100);
            } else {
                setLoading(false);
                setError('Login failed. Please try again.');
            }
        })
        .catch(error => {
            setLoading(false);

            if (error.response && error.response.data) {
                // Check if error response is already an object or needs parsing
                let errorData;
                if (typeof error.response.data === 'string') {
                    try {
                        errorData = JSON.parse(error.response.data);
                    } catch (e) {
                        errorData = { error: 'Server error occurred' };
                    }
                } else {
                    errorData = error.response.data;
                }
                setError(errorData.error || 'Login failed. Please check your credentials.');
            } else {
                setError('Network error. Please try again.');
            }
        });

    }
    return (
        <div className="auth-main-content auth-bg-image">
            <div className="d-table">
                <div className="d-tablecell">
                    <div className="auth-box">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <div className="form-content pe-md-4">
                                    <div className="text-center mb-4">
                                        <h1 className="heading">Registrarse</h1>
                                        <p className="text-muted mb-0">Consulta nuestros precios y registra tu empresa!</p>
                                    </div>

                                    <div className="d-grid gap-3">
                                        <Button
                                            as={Link}
                                            to="/pricing"
                                            size="lg"
                                            className="d-flex align-items-center justify-content-center gap-2"
                                            style={{
                                                backgroundColor: '#dc4a38',
                                                borderColor: '#dc4a38',
                                                color: '#ffffff'
                                            }}
                                        >
                                            <Icon.Home size={18} />
                                            Ver Precios y Registrarse
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-content ps-md-4">
                                    <h1 className="heading">Log In</h1>

                                    <Form onSubmit={onLoginHandler}>
                                        {error && (
                                            <Alert variant="danger" className="mb-3">
                                                {error}
                                            </Alert>
                                        )}

                                        <Form.Group className='mb-3' controlId="email">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control name="email" type="email" required disabled={loading} />
                                        </Form.Group>

                                        <Form.Group className='mb-3' controlId="password">
                                            <Form.Label>Contraseña</Form.Label>
                                            <Form.Control name="password" type="password" required disabled={loading} />
                                        </Form.Group>

                                        <div className="mb-3">
                                            <Button variant="primary" type="submit" disabled={loading} className="w-100">
                                                {loading ? 'Ingresando...' : 'Ingresar'}
                                            </Button>
                                        </div>

                                        <div className="text-center">
                                            <Link to="/recuperar-contrasena" className="text-muted small">
                                                Olvide mi contrasena
                                            </Link>
                                        </div>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
